import { useCallback, useMemo } from 'react';
import { useIoContext } from '~/contexts';
import { useAppConfig } from '~/store/store-context';
export function useNativeOAuthSignIn(provider) {
    const { browser: { changeLocation }, isNativePlatform, native: { openSystemBrowser }, localStorage } = useIoContext();
    const { generateUniqueId } = useAppConfig();
    const isNative = isNativePlatform();
    const state = useMemo(()=>isNative ? "native-".concat(generateUniqueId('native')) : undefined, [
        isNative,
        generateUniqueId
    ]);
    const dispatchOAuth = useCallback(async (authUrl)=>{
        if (isNative && state != null) {
            const { persistPendingOAuthState } = await import('~/native/oauth-state-storage');
            persistPendingOAuthState(localStorage, provider, state);
            await openSystemBrowser(authUrl);
            return;
        }
        changeLocation(authUrl);
    }, [
        isNative,
        state,
        localStorage,
        provider,
        openSystemBrowser,
        changeLocation
    ]);
    return {
        isNative,
        state,
        dispatchOAuth
    };
}
